import { get } from './client';
import { buildPath, toJson } from './utils';
import { CHANNELS } from './constants';
import { GeneralListType } from './types';
import { Channel } from './admin/models';

export const getChannels = (options: any): Promise<GeneralListType<Channel>> =>
  get(buildPath(CHANNELS), options).then(toJson);
